<template>
  <div class>
    <STable ref="tableref" :url="url" :selection="false" :columns="columns" :handles="handles" :query="query"
      :toolbar="toolbar" label-width="120px" />
  </div>
</template>
<script>
export default {
  name: 'Daozhaguanli',
  components: {},
  data() {
    return {
      url: '/business/brake/page',
      columns: [
        {
          label: '电站名称',
          prop: 'stationName'
        },
        {
          label: '道闸品牌',
          prop: 'name'
        },
        {
          label: '修改人',
          prop: 'updater'
        },
        {
          label: '修改时间',
          prop: 'updateDate'
        }
      ],
      // 操作栏
      handles: {
        width: 200,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'valueadd.gate.management.details',
            handle: resp => {
              this.$router.push({ path: './gateDetail', query: { data: resp.id } })
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'valueadd.gate.management.update',
            handle: resp => {
              this.$router.push({ path: './reviseGate', query: { data: resp.id } })
            }
          },
          {
            label: '删除',
            permission: 'valueadd.gate.management.delete',
            style: 'color:red',
            url: '/business/brake',
            isConfirm: true,
            confirmText: '道闸删除后，会影响场站享受的停车优免，是否确认执行本操作？',
            method: 'get',
            before: (index, record) => {
              const ids = record.id
              return { id: ids }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        // {
        //   label: '电站名称',
        //   prop: 'stationId',
        //   placeholder: '请输入电站名称',
        //   type: 'select2',
        //   data: [],
        //   remoteMethod: (val) => {
        //     this.getStation(val)
        //   }
        // },
        {
          label: '电站名称',
          prop: 'stationName',
          placeholder: '请输入电站名称'
        },
        {
          label: '道闸品牌',
          prop: 'name',
          placeholder: '请选择道闸品牌',
          type: 'select',
          data: [
            {
              label: '科拓',
              value: '科拓'
            },
            {
              label: '中安智谷',
              value: '中安智谷'
            },
            {
              label: 'bolink',
              value: 'bolink'
            },
            {
              label: '坤泊',
              value: '坤泊'
            },
            {
              label: '喜鹊云',
              value: '喜鹊云'
            },
            {
              label: '立方',
              value: '立方'
            },
            {
              label: '宁波道闸',
              value: '宁波道闸'
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'valueadd.gate.management.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addGate')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
    this.getStation()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  },
  methods: {
    getStation(val) {
      this.query[0].data = []
      const data = {
        stationName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/brake/getStationByName',
        data: data,
        callback: resp => {
          if (resp) {
            this.query[0].data = resp
          }
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}

</script>
<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/systemManagement/gatemanagement.vue